module.exports = __webpack_public_path__ + "img/grey.ae6a21f.svg";